import { Component } from "react";
import { withRouter } from "react-router-dom";

const ZENDESK_SCRIPT_ID = "ze-snippet";
const ZENDESK_SCRIPT_SRC =
  "https://static.zdassets.com/ekr/snippet.js?key=ac9e9657-1760-4172-9707-cb6e77f7c609";

// Add future FAQ or customer-care routes here when those pages are introduced.
export const CHATBOT_ROUTES = ["/profile"];

export const isChatbotRoute = (pathname) =>
  CHATBOT_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

class Chatbot extends Component {
  isEnabled = false;
  isInitialized = false;

  componentDidMount() {
    this.syncVisibility();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.syncVisibility();
    }
  }

  componentWillUnmount() {
    this.isEnabled = false;
    this.hide();
  }

  getMetadata = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fields = [
      { id: "32029301330589", value: timezone },
      { id: "31943203621021", value: window.location.hostname },
      { id: "5716867531933", value: sessionStorage.getItem("msisdn") },
    ];

    return fields.filter(
      (field) => field.value != null && field.value !== ""
    );
  };

  initialize = () => {
    if (this.isInitialized || typeof window.zE !== "function") return;

    this.isInitialized = true;
    window.zE("messenger:on", "open", () => {
      window.zE("messenger:set", "conversationFields", this.getMetadata());
    });
  };

  load = () => {
    const existingScript = document.getElementById(ZENDESK_SCRIPT_ID);

    if (existingScript) {
      if (typeof window.zE === "function") {
        this.show();
      } else {
        existingScript.addEventListener("load", this.handleScriptLoad, {
          once: true,
        });
      }
      return;
    }

    const script = document.createElement("script");
    script.id = ZENDESK_SCRIPT_ID;
    script.src = ZENDESK_SCRIPT_SRC;
    script.async = true;
    script.addEventListener("load", this.handleScriptLoad, { once: true });
    document.head.appendChild(script);
  };

  handleScriptLoad = () => {
    if (this.isEnabled) this.show();
    else this.hide();
  };

  show = () => {
    if (typeof window.zE !== "function") return;
    this.initialize();
    window.zE("messenger", "show");
  };

  hide = () => {
    if (typeof window.zE !== "function") return;
    window.zE("messenger", "close");
    window.zE("messenger", "hide");
  };

  syncVisibility = () => {
    this.isEnabled = isChatbotRoute(this.props.location.pathname);

    if (this.isEnabled) this.load();
    else this.hide();
  };

  render() {
    return null;
  }
}

export default withRouter(Chatbot);
